/**
 * Hook for managing verification code input field
 */
import { useMemo, useState } from "react";
import { useSignup as useSignupContext } from "../../SignupContext";
import { validateVerificationCode } from "../../validation";
export function useVerificationCode() {
    const { formValues, setFormValues } = useSignupContext();
    const [touched, setTouched] = useState(false);
    const [blurred, setBlurred] = useState(false);
    const validation = useMemo(() => {
        // Validate using the current locale
        return validateVerificationCode(formValues.verificationCode);
    }, [formValues.verificationCode, formValues.language]); // Include language for reactivity
    return useMemo(() => ({
        value: formValues.verificationCode,
        touched,
        blurred,
        isValid: validation.isValid,
        errorMessage: validation.errorMessage,
        setValue: setFormValues.setVerificationCode,
        setTouched,
        setBlurred,
    }), [
        formValues.verificationCode,
        touched,
        blurred,
        validation,
        setFormValues.setVerificationCode,
    ]);
}
